export default {
    active: 'Actif',
    completed: 'Complétée',
    pending: 'En attente',
    deactivated: 'Annulée',
};
